import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, getcountries, deleteData } from '../../../services/event/emleadsForms/empastconfProceedingsListsServices';
import DataTable from 'react-data-table-component';
import { Modal, Button} from 'react-bootstrap';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';

const subDomain = localStorage.getItem('sub_domain') || '';

const EmPastconfProceedingsLists = () => {
  const [dataList, setDataList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    countries: []
  });
  
  // Fetch data list
  const fetchData = useCallback(async () => {
      try {
        const data = await getData({sub_domain: subDomain });
        setDataList(data);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    }, []);
  
  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries()
      ]);
 
      setDropdownData({
        countries: country
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData(); 
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData,fetchDropdownData]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  //delete
    const handleDelete = async () => {
        if (selectedData) {
          // Optimistically remove the data from the list
          setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
          // Proceed with the actual delete request
          await deleteData(selectedData);
          setShowDeleteConfirmModal(false);
        }
    };
  
    const openDeleteConfirmModal = (data) => {
      setSelectedData(data);
      setShowDeleteConfirmModal(true);
    };
     
  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;
    return dataList
      .filter((data) => {
        // Text-based search (case-insensitive)
        const matchesText =
        data.fullname.toLowerCase().includes(searchText.toLowerCase()) ||
        data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
        data.country.toLowerCase().includes(searchText.toLowerCase()) ||
        data.contactnumber.toString().includes(searchText.toLowerCase()) ||
        data.email.toString().includes(searchText.toLowerCase());
      
          // Convert abstract_date to Date for comparison
        const date = data.updatedAt ? new Date(data.updatedAt) : null;
    
          // Date range filtering
          const inRange = (startDateObj && endDateObj)
            ? date >= startDateObj && date <= endDateObj
            : true;
  
        // Country dropdown filtering
        const matchCountry = !countryFilter || data.country === countryFilter;
  
        return matchesText && inRange && matchCountry;
        })
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
    }, [dataList, searchText, startDate, endDate, countryFilter]);
  
    const columns = [
      {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '60px',
      },
      {
        name: 'Date',
        selector: (row) => new Date(row.createdAt).toLocaleDateString('en-CA'),
        sortable: true,
      },
      {
        name: 'Sub Domain',
        selector: (row) => row.sub_domain,
        sortable: true,
      },
      {
        name: 'Full Name',
        selector: (row) => row.fullname,
        sortable: true,
      },
      {
        name: 'Email',
        selector: (row) => row.email,
        sortable: true,
      },
      {
          name: 'country',
          selector: (row) => getCountryName(row.country),
          sortable: true,
      },
      {
          name: 'Contact Number',
          selector: (row) => row.contactnumber	,
          sortable: true,
      },
      {
        name: 'Actions',
        cell: (row) => (
          <div>
            <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > <i className="align-middle fas fa-fw fa-trash"></i> </Button>
          </div>
        ),
      },      
    ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
            <span>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        </div>
        {loading ? (
                        <div
                          className="d-flex justify-content-center align-items-center w-100"
                          style={{ minHeight: "300px" }}
                        >
                          <Spinner /> {/* Centered Spinner */}
                        </div>
                                ) :(
                          <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='fs-4'>Conference Leads / Leads Forms / Past Proceedings Lists</p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }           
          />

           {/* Delete Confirmation Modal */}
            <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to delete this row?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Yes, Delete
                </Button>
              </Modal.Footer>
            </Modal>
        </div>
        <Footer />
        </div>
          )};
      </div>
    </div>
  );
};

export default EmPastconfProceedingsLists;
